<script>
import Popin from "@/components/molecules/popin";
import WidgetPlanningTabClickCollect from "@/containers/widgetPlanningTabClickCollect";
export default {
  name: "PopinConfirmationMagasin",
  components: {
    Popin,
    WidgetPlanningTabClickCollect
  },
  props: {
    showPlanningClickCollect: {
      type: Boolean,
      required: false,
      default: false
    },
    magasin: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  emits: ["closed"],
  methods: {
    show() {
      this.$refs.popin.show();
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    size="lg"
    :visible="showPlanningClickCollect"
    aria-label="Planning Click & Collect"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    @closed="$emit('closed')"
  >
    <WidgetPlanningTabClickCollect :magasin="magasin" />
  </Popin>
</template>

<style lang="scss" scoped>
</style>
